function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this,
        args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

    
    // Assign active class to nav links while scolling
    var sideMenu = document.querySelector("#on-page-navigation");
    if (sideMenu) {
 
        "use strict";
        var section = document.querySelector('#main').querySelectorAll(".page-section");

        var sections = {};
        var i = 0;

        Array.prototype.forEach.call(section, function(e) {
          sections[e.id] = e.offsetTop;
        });
        document.querySelector("#on-page-navigation li").classList.add("active");

        var obsOptions = {
          root: null, // measure against the viewport
          threshold: 0, // how much of the element should be visible before handler is triggered
        };
    
    
        window.onscroll = debounce(function() {
          var scrollPosition =
            document.documentElement.scrollTop || document.body.scrollTop;
  
          for (i in sections) {
            if (sections[i] <= scrollPosition) {
              document.querySelector(".active").setAttribute("class", " ");
              document
                .querySelector("#on-page-navigation a[href*=" + i + "]").parentElement
                .setAttribute("class", "active");
            }
          }
        }, 5);
    
    }
